module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhead2-3613c05ef92dc6e59a2efe216470d831.jpg";